<template>
  <div>
    <asc-autocomplete-selector
      v-model="airlineId"
      class="asc-airline-agreement-form--row-dropdown"
      :items="airlineOptions"
      label="Airlines"
      required
      no-array
      fixed-position
    ></asc-autocomplete-selector>
    <asc-autocomplete-selector
      v-model="masterModelId"
      class="asc-airline-agreement-form--row-dropdown"
      :items="platforms"
      label="Platform"
      required
      fixed-position
      component-type="multiple"
    ></asc-autocomplete-selector>
    <asc-autocomplete-selector
      v-model="airlineAgreementTypeId"
      class="asc-airline-agreement-form--row-dropdown"
      :items="agreementsOptions"
      label="PHM Agreement"
      required
      no-array
      fixed-position
    ></asc-autocomplete-selector>
    <asc-date-picker
      v-model="fromDate"
      class="asc-airline-agreement-form--row-date1"
      label="Start Date"
      format="DD MMM YYYY"
      icon-position="right"
      :icon-action="false"
      required
    />
    <asc-date-picker
      v-model="toDate"
      class="asc-airline-agreement-form--row-date2"
      label="End Date"
      format="DD MMM YYYY"
      icon-position="right"
      :icon-action="false"
      allow-future-dates
      required
    />
    <div class="asc-airline-agreement-form--checkbox">
      <asc-checkbox
        v-model="isBillable"
        label="Billable"
        :checked="isBillable"
      ></asc-checkbox>
    </div>
  </div>
</template>

<script>
import AscDatePicker from '@/components/atoms/AscDatePicker'
import AscAutocompleteSelector from './AscAutocompleteSelector'
import variables from '@/styles/_varsJs.scss'
import AscCheckbox from '@/components/atoms/AscCheckbox'

export default {
  name: 'AscAirlineAgreementForm',

  components: {
    AscDatePicker,
    AscAutocompleteSelector,
    AscCheckbox,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: variables.gray700,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    agreements: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    airlineId: {
      get() {
        return this.data?.airlineId
      },
      set(val) {
        this.update({
          airlineId: val,
        })
      },
    },
    masterModelId: {
      get() {
        return this.data?.masterModelId
      },
      set(val) {
        this.update({
          masterModelId: val,
        })
      },
    },
    airlineAgreementTypeId: {
      get() {
        return this.data?.airlineAgreementTypeId
      },
      set(val) {
        this.update({
          airlineAgreementTypeId: val,
        })
      },
    },
    fromDate: {
      get() {
        return this.data?.fromDate
      },
      set(val) {
        this.update({
          fromDate: val,
        })
      },
    },
    toDate: {
      get() {
        return this.data?.toDate
      },
      set(val) {
        this.update({
          toDate: val,
        })
      },
    },
    isBillable: {
      get() {
        return this.data?.isBillable
      },
      set(val) {
        this.update({
          isBillable: val,
        })
      },
    },
    airlineOptions() {
      if (this.airlines) {
        const filteredAirlines = this.airlines
          .filter(item => item.isActive)
          .map(item => {
            return {
              text: item.name,
              value: item.id,
            }
          })
        return filteredAirlines
      } else {
        return []
      }
    },
    agreementsOptions() {
      if (this.agreements) {
        return this.agreements.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      } else {
        return []
      }
    },
  },

  methods: {
    update(propToOverwrite) {
      const mergedInfo = {
        ...this.data,
        ...propToOverwrite,
      }
      this.$emit('update', mergedInfo)
    },
  },
}
</script>

<style lang="scss">
.asc-airline-agreement-form {
  &--row {
    &-dropdown {
      width: 100%;
      padding: 10px;
    }

    &-date2 {
      width: 100%;
      padding: 10px;
    }

    &-date1 {
      width: 100%;
      padding: 0 10px;
      margin-top: 20px;
    }
  }

  &--checkbox {
    padding: 0 10px 10px 10px;

    & > .asc-checkbox > div > label {
      color: $gray-700;
    }
  }
}
</style>
